import axios from "axios";

const instance = axios.create({
    baseURL: process.env.VUE_APP_ASSESSMENT_API_URL
});
export default {
    install(Vue) {
        Vue.prototype.$featureFlags = {
            flags: {},

            async init() {
                try {
                    const { data } = await instance.get('flags', {});
                    this.flags = data.flags;
                } catch (error) {
                    console.error('Failed to load feature flags:', error);
                    this.flags = {}; // Default to empty object
                }
            },

            isEnabled(flagName) {
                return this.flags[flagName] === true;
            }
        };
    }
};